import { render, staticRenderFns } from "./mobile-nav.vue?vue&type=template&id=88a565cc&scoped=true&lang=pug&"
import script from "./mobile-nav.vue?vue&type=script&lang=js&"
export * from "./mobile-nav.vue?vue&type=script&lang=js&"
import style0 from "./mobile-nav.vue?vue&type=style&index=0&id=88a565cc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88a565cc",
  null
  
)

/* custom blocks */
import block0 from "./mobile-nav.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {WidgetsListItem: require('/home/ubuntu/nuxt/bonkers/releases/20230602131631/components/widgets/list-item.vue').default})
